import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.pedidos_api.pedidos_ya;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Store availability operations
export const openStore = async (localId: number) => {
  return await api.post(`/OpenStore/${localId}`);
};

export const closeStore = async (localId: number, reason?: string) => {
  return await api.post(`/CloseStore/${localId}`, { reason: reason || 'CLOSED' });
};

export const getStoreAvailability = async (localId: number) => {
  return await api.get(`/GetStoreAvailability/${localId}`);
};

export const updateStoreAvailability = async (localId: number, data: {
  availabilityState: string;
  platformKey: string;
  platformRestaurantId: string;
}) => {
  return await api.put(`/UpdateStoreAvailability/${localId}`, data);
};

// Menu operations
export const createPedidosYaCatalogFromLocalId = async (localId: number) => {
  return await api.post(`/CreatePedidosYaCatalogFromLocalId/${localId}`);
};

export const submitCatalog = async (localId: number) => {
  return await api.post(`/SubmitCatalog/${localId}`);
};

export const getCatalogByLocalId = async (localId: number) => {
  return await api.get(`/GetCatalogByLocalId/${localId}`);
};

export const validateCatalog = async (localId: number) => {
  return await api.get(`/ValidateCatalog/${localId}`);
};

export const getCatalogImportStatus = async (catalogImportId: string) => {
  return await api.get(`/GetCatalogImportStatus/${catalogImportId}`);
};

// Item availability operations
export const updateItemAvailability = async (localId: number, data: {
  item_ids_off?: number[];
  item_ids_on?: number[];
}) => {
  return await api.put(`/UpdateItemAvailability/${localId}`, data);
};

export const syncStockAvailability = async (localId: number) => {
  return await api.post(`/SyncStockAvailability/${localId}`);
};

export const getUnavailableItems = async (localId: number) => {
  return await api.get(`/GetUnavailableItems/${localId}`);
};